import { render, staticRenderFns } from "./StockRegisterPage1.vue?vue&type=template&id=2d90fb4a&scoped=true&"
import script from "./StockRegisterPage1.vue?vue&type=script&lang=js&"
export * from "./StockRegisterPage1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d90fb4a",
  null
  
)

export default component.exports